/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Instantiate_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not create the project from the template." |
*
* @param {Templates_Instantiate_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const templates_instantiate_error = /** @type {((inputs?: Templates_Instantiate_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Instantiate_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt konnte nicht aus der Vorlage erstellt werden.")
	return /** @type {LocalizedString} */ ("Could not create the project from the template.")
});